const DEFAULT_MEDIA_BASE_URL = 'https://ntptourism.com/media';
const OPTIMIZED_MEDIA_BASE_URL = '/optimized-media';
const OPTIMIZABLE_IMAGE_PATTERN = /\.(?:jpe?g|png|webp)$/i;
const HOSTED_MEDIA_IMAGE_PATTERN = /\/media\/(assets\/[^?#]+\.(?:jpe?g|png|webp))(?:[?#].*)?$/i;

export const MEDIA_BASE_URL = (
  import.meta.env.VITE_MEDIA_BASE_URL ||
  DEFAULT_MEDIA_BASE_URL
).replace(/\/$/, '');

export const originalMediaAsset = (path) => {
  const value = String(path || '');
  if (/^https?:\/\//i.test(value)) return value;
  const normalizedPath = value.replace(/^\/+/, '');
  return `${MEDIA_BASE_URL}/${normalizedPath}`;
};

export const optimizeMediaUrl = (value) => {
  const source = String(value || '');
  if (source.startsWith('/optimized-media/')) return source;

  const hostedMatch = source.match(HOSTED_MEDIA_IMAGE_PATTERN);
  if (hostedMatch) {
    return `${OPTIMIZED_MEDIA_BASE_URL}/${hostedMatch[1].replace(OPTIMIZABLE_IMAGE_PATTERN, '.webp')}`;
  }

  const normalizedPath = source.replace(/^\/+/, '');
  if (normalizedPath.startsWith('assets/') && OPTIMIZABLE_IMAGE_PATTERN.test(normalizedPath)) {
    return `${OPTIMIZED_MEDIA_BASE_URL}/${normalizedPath.replace(OPTIMIZABLE_IMAGE_PATTERN, '.webp')}`;
  }

  return source;
};

export const resolveMediaUrl = (value) => {
  return optimizeMediaUrl(value);
};

export const mediaAsset = (path) => {
  const value = String(path || '');
  if (import.meta.env.DEV) {
    const normalizedPath = value.replace(/^\/+/, '');
    if (normalizedPath.startsWith('assets/')) {
      if (OPTIMIZABLE_IMAGE_PATTERN.test(normalizedPath)) {
        return `${OPTIMIZED_MEDIA_BASE_URL}/${normalizedPath.replace(OPTIMIZABLE_IMAGE_PATTERN, '.webp')}`;
      }
      return `/src/${normalizedPath}`;
    }
  }
  const optimizedUrl = optimizeMediaUrl(value);
  if (optimizedUrl !== value) return optimizedUrl;
  if (/^https?:\/\//i.test(value)) return value;
  const normalizedPath = value.replace(/^\/+/, '');

  return originalMediaAsset(normalizedPath);
};

export const responsiveMediaSrcSet = (value) => {
  if (import.meta.env.DEV) return '';
  const optimizedUrl = optimizeMediaUrl(value);
  if (!/^\/optimized-media\/assets\/.+\.webp(?:[?#].*)?$/i.test(optimizedUrl)) return '';
  const base = optimizedUrl.replace(/\.webp(?:[?#].*)?$/i, '');
  return `${base}-640.webp 640w, ${base}-1280.webp 1280w, ${base}-1600.webp 1600w`;
};

export const localMediaAsset = (path) => {
  const normalizedPath = String(path || '').replace(/^\/+/, '');
  return `/media/${normalizedPath}`;
};
